<script>
    import RadioGroup from './RadioGroup.svelte';

    export let label = "";
    export let name;
    export let value;

    export let orientation = "horizontal";

    export let required = null;
    export let disabled = null;

</script>

<RadioGroup name="{name}"
            bind:value="{value}"
            optionList={[ { label: "Yes", value: "True" },  { label: "No", value: "False" }]}
            {label}
            {required}
            {disabled}
            {orientation}
            on:change></RadioGroup>
